/*
kavyareddy 02/2/2023 2699234404 Added Scheduler execution history
 */
import React from 'react';
import SearchSchedulerContainer from '../SearchExecutionHistory/SearchSchedulerContainer';

const SearchExecutionHistory = () => {
  return (
    <div>
      <SearchSchedulerContainer />
    </div>
  );
};

export default SearchExecutionHistory;
